import { useEffect, useState } from "react";
import API from "../Network/API";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PostLoader from '../assets/loader.gif';

import { useSelector } from "react-redux";
import UserAvatar from "../components/UserAvatar";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import moment from "moment";
import { useTranslation, Trans } from "react-i18next";
import toast from "react-hot-toast";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export default function Checkout() {
  const { t } = useTranslation();

  const [checkoutOptions, setCheckoutOptions] = useState(null);
  const { user, accessToken } = useSelector((state) => state.authReducer);
  const prams = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith("/app");
  const [data, setData] = useState();
  const [isLoading, setLoading] = useState(false);
  const [timezone, setTimezone] = useState('');
  const [fee, setFee] = useState(0);
  const event = JSON.parse(localStorage.getItem("event"));
  const lesson = JSON.parse(localStorage.getItem("lesson"));
  const isFree = data != null && Number(data?.price ?? 0) <= 0;
  const hasReviews = Number(data?.avg_rating ?? 0) > 0 && Number(data?.total_review ?? 0) > 0;

  useEffect(() => {

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const cart = JSON.parse(localStorage.getItem("data_checkout"));
    setData(cart)

    setTimezone(timezone);

    // free orders skip Stripe entirely — no payment intent needed
    if (Number(cart?.price ?? 0) <= 0) {
      return;
    }

    // price is computed server-side in USD; Stripe Adaptive Pricing localises it (e.g. AED) inside the embedded checkout
    setLoading(true)
    const orderProcessPath = `${isAppRoute ? '/app' : ''}/order/process`;
    API.post(`/v1/oauth/create-checkout-session`, {
      course_id: cart?.course_id,
      lesson_id: cart?.lesson_id,
      return_url: window.location.origin + orderProcessPath,
    }).then((response) => {
      const { clientSecret, sessionId } = response.data;
      setCheckoutOptions({
        clientSecret,
        // card / wallet payments finish in-page; redirect-based methods use the session's return_url instead
        onComplete: () => navigate(`${orderProcessPath}?session_id=${sessionId}`),
      });
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
      toast.error(error?.response?.data?.message || t('checkout.checkout_load_failed'))
    });


  }, [prams.slug]);

  // free enrollment goes through the same order pipeline, just without a Stripe payment
  const enrollFree = () => {
    navigate(`${isAppRoute ? '/app' : ''}/order/process?redirect_status=succeeded&payment_intent=free_checkout`);
  };




  return (
    <>
      {isLoading ?
        <div className='content' style={{ margin: 'auto', padding: 'auto', textAlign: 'center', height: '500px' }}>
          <img src={PostLoader} alt={t('checkout.post_loader')} height={80} width={80} />
        </div>
        :
        <div className="payment-checkuot">
          <div className="container">
            <div className="row m-0">
              <div className="col-md-7 col-12">
                <div className="box-right ">
                  <div className="row">
                    <div className="col-12">
                      <div className="checkout-course-head d-flex">
                        <div className="flex-shrink-0">
                          <UserAvatar src={data?.teacher_image} name={data?.teacher_name} size={64} />
                        </div>
                        <div className="flex-grow-1 ms-3 min-w-0">
                          <p className="checkout-kicker mb-1">
                            {data?.course_type === 'recorded' ? t('checkout.recorded_course') : t('checkout.live_lesson')}
                          </p>
                          <h4 className="checkout-course-title">{data?.course_title}</h4>
                          {data?.course_type !== 'recorded' && lesson?.title &&
                            <p className="checkout-lesson-line mb-1"><i className="fa-light fa-book-open me-2" />{lesson.title}</p>
                          }
                          <p className="checkout-teacher-line mb-0">
                            <Trans i18nKey="checkout.with_teacher" values={{ name: data?.teacher_name }} components={{ b: <b /> }} />
                            {hasReviews &&
                              <span className="checkout-rating ms-2">
                                <i className="fa-solid fa-star" /> {data?.avg_rating}
                                <span className="checkout-rating-count"> {Number(data?.total_review) === 1 ? t('checkout.review_count_single', { count: data?.total_review }) : t('checkout.review_count_multiple', { count: data?.total_review })}</span>
                              </span>
                            }
                          </p>
                          <div className="checkout-chips mt-2">
                            <span className="checkout-chip"><i className="fa-light fa-badge-check me-1" />{t("checkout.verified")}</span>
                            <span className="checkout-chip"><i className="fa-light fa-award me-1" />{t("checkout.professional")}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`row justify-content-center ${data?.course_type=='recorded'?'d-none':'d-block'}`}>
                    <div className="col-md-10 d-none">
                      <div className="checkoutHeading-payment-form-btn mt-4">
                        {/* Credit card form tabs */}
                        <ul role="tablist" className="nav bg-light nav-pills rounded nav-fill mb-3 checkoutPayment">
                          <li className="nav-item"> <a data-toggle="pill" href="#credit-card" className="nav-link active "> <span className="d-block fw-bold">{t("checkout.mins", { count: 25 })}</span> <span className="d-block fw-bold">BDT 1,208</span></a> </li>
                          <li className="nav-item"> <a data-toggle="pill" href="#paypal" className="nav-link "> <span className="d-block fw-bold">{t("checkout.mins", { count: 50 })}</span> <span className="d-block fw-bold">BDT 1,908</span></a></li>
                        </ul>
                      </div> {/* End */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="Divider-sc" />
                    </div>
                  </div>
                  <div className={`row ${data?.course_type=='recorded'?'d-none':'d-block'}`}>
                    <div className="col-12">
                      <div className="course-schedule">
                        <p className="course-schedule-time mb-0">{ moment.tz(event?.start, timezone).format('YYYY-MM-DD hh:mm A') } {timezone}</p>
                        <p className="course-schedule-location mb-0">{t("checkout.time_based_on_location")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="Divider-sc" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="order-heading mb-3">
                        <h2>{t("checkout.your_order")}</h2>
                      </div>
                      <div className="order-dec">
                        <div className="d-flex justify-content-between order-dec-item">
                          <p className="order-dec-item-name">{t("checkout.sub_total")}</p>
                          <p className="order-dec-item-price fw-bold">${Number(data?.price ?? 0).toFixed(2)}</p>
                        </div>
                      </div>
                      <div className="order-dec">
                        <div className="d-flex justify-content-between order-dec-item">
                          <p className="order-dec-item-name">{t("checkout.processing_fee")}</p>
                          <p className="order-dec-item-price fw-bold">${Number(fee).toFixed(2)}</p>
                        </div>
                      </div>
                      <div className="order-dec mb-3">
                        <div className="d-flex justify-content-between mb-2 mt-2 order-dec-total-item">
                          <p className="order-dec-item-total-name">{t("checkout.total")}</p>
                          <p className="order-dec-item-total-price">${(Number(data?.price)+Number(fee)).toFixed(2)}</p>
                        </div>
                        {!isFree && <p className="textmuted text-small-12 mb-0">{t("checkout.local_currency_note")}</p>}
                      </div>
                    </div>
                  </div>
                  <div className="row d-none">
                    <div className="col-8">
                      <input className="form-control input-hight-44" type="text" placeholder={t("checkout.enter_promo_code")} />
                    </div>
                    <div className="col-4">
                      <a href="#" className="btn rounded btn-light w-100 input-hight-44 pt-2">
                        {t("checkout.apply")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-12 ps-md-5 p-0 ">
                <div className="box-left">
                  {isFree ?
                    <div className="free-enroll-panel text-center">
                      <span className="free-enroll-badge"><i className="fa-light fa-gift me-2" />{t("checkout.free")}</span>
                      <h2 className="free-enroll-title">{t("checkout.no_payment_needed")}</h2>
                      <p className="free-enroll-dec">{data?.course_type === 'recorded' ? t('checkout.free_course_desc') : t('checkout.free_lesson_desc')}</p>
                      <button type="button" onClick={() => enrollFree()} className="btn rounded becomeTutor-btn w-100">
                        {t("checkout.enroll_for_free")}<i className="fa-light fa-arrow-right ms-2" />
                      </button>
                      <p className="free-enroll-note">{t("checkout.no_card_required")}</p>
                    </div>
                    :
                    <div className="checkoutHeading-payment-form">
                      <div className="checkoutHeading-payment-form-btn">
                        {/* Credit card form tabs */}
                        <ul role="tablist" className="nav bg-light nav-pills rounded nav-fill mb-3 checkoutPayment">
                          <li className="nav-item"> <a data-toggle="pill" href="#credit-card" className="nav-link active "> <i className="fa-light fa-credit-card me-2" /> {t("checkout.checkout_now")} </a> </li>
                        </ul>
                      </div> {/* End */}
                      {/* Credit card form content */}
                      <div className="tab-content">
                        {/* credit card info*/}
                        <div id="credit-card" className="tab-pane fade show active pt-3 credit-card">
                          <div className="form">

                              {checkoutOptions && (
                                <EmbeddedCheckoutProvider options={checkoutOptions} stripe={stripePromise}>
                                  <EmbeddedCheckout />
                                </EmbeddedCheckoutProvider>
                              )}


                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}